/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import NotificationBell from "../../../../components/Notification/NotificationBell";
import SecondaryLargeButton from "../../../../components/_utils/CommonButtons/SecondaryLargeButton/SecondaryLargeButton";
import TertiaryTopRoundButton from "../../../../components/_utils/CommonButtons/TertiaryTopRoundButton/TertiaryTopRoundButton";
import CommonCardDashboard from "../../../../components/_utils/CommonCardDashboard";
// import CommonMoreActionsCard from "../../../../components/_utils/CommonMoreActionsCard";
import {
  remitterAccountViewAll,
  resetRemitterToggle,
} from "../../../../redux/features/accounts/remitterAccount/remitterAccount";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { resetServices } from "../../../../redux/features/refreshToken/refreshToken";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText";
import useInitials from "../../../../utils/useInitials";
// import { globalTextFormat } from "../../../../utils/globalTextFormat";

const RemitterAccountDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initials = useInitials();

  const { remitterAccountViewAllData, remitterAccountViewAllLoading } =
    useSelector((state) => state.remitterAccount);

  const services = useSelector((state) => state.refreshToken.services) ?? [];
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const viewService = "REVAccount";
  const createService = "REUAccount";
  const approvalService = "REAAccount";

  const summary = remitterAccountViewAllData?.summary || {};

  const hasCreatePermission = services.includes(createService);

  const hasApprovalPermission = services.includes(approvalService);

  const hasViewPermission =
    services.includes(viewService) ||
    services.includes("MimicEntity") ||
    services.includes("Admin");

  const isRequireApprovalFlow = hasApprovalPermission;

  const hasPendingApprovedService = hasViewPermission;

  const totalCount =
    remitterAccountViewAllData?.total_count ??
    GlobalConfiguration?.lengthCheckZero;

  const pendingCount =
    remitterAccountViewAllLoading && !remitterAccountViewAllData
      ? null
      : (summary?.pending_accounts_count ?? "00");

  const approvedCount =
    remitterAccountViewAllLoading && !remitterAccountViewAllData
      ? null
      : !hasPendingApprovedService
        ? "N/A"
        : (summary?.approved_accounts_count ?? "00");

  const isViewAllDisabled =
    remitterAccountViewAllLoading ||
    services.length === 0 ||
    totalCount === GlobalConfiguration?.lengthCheckZero;

  const handleDatacardClick = (approvalStatus) => {
    dispatch(resetRemitterToggle());

    if (approvalStatus === "pending") {
      if (hasApprovalPermission) {
        navigate("/remitter_account_dashboard/remitter_account_approval");
        return;
      }

      if (hasViewPermission) {
        navigate("/remitter_account_dashboard/remitter_account_view_all", {
          state: { approvalStatus },
        });
        return;
      }

      navigate("/feature_not_assigned", {
        state: { unavailableService: approvalService },
      });

      return;
    }

    if (hasViewPermission) {
      navigate("/remitter_account_dashboard/remitter_account_view_all", {
        state: { approvalStatus },
      });
    } else {
      navigate("/feature_not_assigned", {
        state: { unavailableService: viewService },
      });
    }
  };

  const handleCreateRemitterAccount = () => {
    if (hasCreatePermission) {
      navigate("/remitter_account_dashboard/create_remitter_account");
      dispatch(resetServices());
    } else {
      navigate("/feature_not_assigned", {
        state: { unavailableService: createService },
      });
    }
  };

  const handleRemitterServiceUnavailable = (service) => {
    navigate("/feature_not_assigned", {
      state: { unavailableService: service },
    });
  };

  const handleViewAllClick = async () => {
    await dispatch(resetRemitterToggle());

    if (hasViewPermission) {
      navigate("/remitter_account_dashboard/remitter_account_view_all", {
        state: { approvalStatus: "all" },
      });
    } else {
      navigate("/feature_not_assigned", {
        state: { unavailableService: viewService },
      });
    }
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    dispatch(
      remitterAccountViewAll({
        page_no: GlobalConfiguration?.lengthCheckOne,
        page_size: PaginationConfiguration?.paginationSmall,
        isDashboardCall: true,
      }),
    );
    return () => {
      dispatch(disableSwitcher());
    };
  }, [markerData]);

  return (
    <div className=" internalDashboardView bg-primary-bg w-width-full overflow-y-auto px-padding-base pb-padding-md h-screen ">
      <div className="Qsmd:h-navbar-breadcrumb-height"></div>
      <div className="flex gap-x-gap-md flex-col mt-margin-md lg:mx-auto pb-padding-xl lg:pb-padding-base max-w-tab-width-normal w-width-full lg:flex-row px-padding-md Qlg:px-padding-md mb-margin-xl lg:mb-margin-base Qlg:relative">
        <div className="Qlg:w-dashboard-left-card-width">
          <div className="w-width-full flex flex-col pt-padding-md Qsmd:pt-padding-base mt-margin-xl Qsmd:mt-margin-base ">
            <div className="Qsmd:hidden w-width-full fixed top-top-base left-left-base right-right-base bg-text-primary flex items-center justify-between z-z-index-fixed-ui rounded-b-border-radius-sm h-[var(--home-nav-mobile-height)] pl-mobile-padding-l pr-mobile-padding-l border-b border-primary-bg shadow-sm">
              <div className="flex items-center">
                <img
                  src={ICONS?.XPENTRA_BLUE}
                  alt="Xpentra Logo"
                  className="w-xpentra-logo-width h-xpentra-logo-height"
                />
              </div>
              <div className="flex gap-gap-sm flex-row items-center ">
                <NotificationBell />
                <div className="w-px h-5 bg-primary-card mx-2"></div>
                <div
                  className="text-xs bg-text-secondary text-primary-bg h-[var(--profile-initials-w-h)] w-[var(--profile-initials-w-h)] flex items-center justify-center rounded-full font-semibold cursor-pointer"
                  onClick={() => navigate("/home/profile_quick_menu")}
                >
                  {initials}
                </div>
              </div>
            </div>
            <div className="w-width-full bg-primary-nav flex flex-col sm:flex-row rounded-border-radius-md items-center z-z-index-header gap-gap-sm">
              <div className="w-width-full flex">
                <SecondaryLargeButton
                  btnText="Create remitter account"
                  btnType="button"
                  handleFunction={handleCreateRemitterAccount}
                  isDisabled={!hasCreatePermission}
                  enabledTextColor="var(--text-primary)"
                  disabledTextColor="var(--text-secondary)"
                  enabledBgColor="var(--primary-nav)"
                  hoverOption="white"
                  isLoaderNeeded={false}
                  isLoading={false}
                  icon={ICONS?.ADD_BUTTON_WHITE}
                  imgColor="var(--text-primary)"
                  iconAlt="add_button_white"
                />
              </div>
            </div>

            <div className="w-width-full rounded-border-radius-md relative overflow-hidden mt-margin-md">
              <h2 className="bg-primary-card flex items-center justify-between pl-padding-md transition-all duration-animation-medium">
                <div className="flex items-center gap-gap-sm">
                  <img
                    src={ICONS?.APPROVAL_STATUS}
                    alt="transaction header"
                    className="w-icon-sm"
                  />
                  <p className="text-font-sm font-semibold font-sans text-text-primary">
                    Accounts
                  </p>
                </div>
                <div className="flex">
                  <div className="border-dividing"></div>
                  <TertiaryTopRoundButton
                    btnText={globalText?.VIEW_ALL}
                    icon={ICONS?.ARROW_RIGHT_WHITE}
                    imgColor="var(--text-primary)"
                    btnType="button"
                    hoverOption="white"
                    handleFunction={() => {
                      if (isViewAllDisabled) return;
                      handleViewAllClick();
                    }}
                    isDisabled={isViewAllDisabled}
                    enabledTextColor={"var(--text-primary)"}
                    disabledTextColor={"var(--text-secondary)"}
                    enabledBgColor={"var(--primary-card)"}
                    disabledBgColor={"var(--primary-card)"}
                  />
                </div>
              </h2>
              <div>
                <div className="flex flex-col Qsmd:flex-row gap-gap-base p-padding-base bg-primary-nav">
                  <CommonCardDashboard
                    label={
                      isRequireApprovalFlow
                        ? globalText?.REQUIRE_APPROVAL
                        : globalText?.PENDING_ACCOUNTS
                    }
                    count={pendingCount}
                    color="var(--pending)"
                    loader={remitterAccountViewAllLoading}
                    onClick={() => handleDatacardClick("pending")}
                  />
                  <div className="border-border border-primary-bg Qsmd:my-margin-md my-margin-base"></div>
                  <CommonCardDashboard
                    label="Approved accounts"
                    count={approvedCount}
                    color="var(--awaiting)"
                    onClick={() => handleDatacardClick("approved")}
                    onServiceUnavailable={() =>
                      handleRemitterServiceUnavailable(viewService)
                    }
                    loader={remitterAccountViewAllLoading}
                  />
                </div>
              </div>
            </div>

            <div className="w-width-full mt-margin-md bg-primary-card rounded-t-border-radius-md rounded-b-border-radius-md">
              <h2 className="bg-primary-card flex items-center justify-between px-padding-md py-padding-sm text-sm font-semibold text-text-secondary transition-all duration-animation-medium rounded-t-border-radius-md">
                <span className="flex items-center text-sm font-semibold text-text-primary">
                  <img
                    src={ICONS?.STATISTICS}
                    alt="Statistics Header"
                    className="h-icon-sm mr-margin-sm"
                  />
                  Remitter accounts
                </span>
              </h2>
              <div className="border-border border-primary-bg mx-margin-md"></div>

              <div className="relative w-width-full lg:py-padding-md overflow-hidden contents lg:block ">
                <div className="flex flex-col items-center justify-center lg:justify-start h-height-full text-center p-padding-md">
                  <div className="flex flex-col justify-center items-center w-width-full">
                    <img
                      src={ICONS?.NO_STATISTICS_AVAILABLE}
                      alt="No Slides"
                      className="mb-margin-sm w-graphic-width-md h-graphic-rectangle-height-md flex-shrink-0"
                    />
                    <p className="text-font-xs text-text-primary">
                      No statistics available due to the absence of data. Once
                      data is present,
                      <br />
                      statistics will appear.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="Qlg:w-dashboard-right-card-width">
          {/* <CommonMoreActionsCard
            title={globalTextFormat(globalText.MORE_ACTIONS, [0])}
            actions={[
              {
                label: "MIS report",
                service: "SMisUser",
                onClick: () => {
                  if (services?.includes("SMisUser")) {
                    navigate("/remitter_account_dashboard/generate_mis_report");
                  } else {
                    navigate("/feature_not_assigned", {
                      state: {
                        unavailableService: "SMisUser",
                      },
                    });
                  }
                },
              },
            ]}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default RemitterAccountDashboard;
